module.exports = __webpack_public_path__ + "assets/1b97cd3c9b5eb2e625ff6992a11b85c4.png";